/**
 * 订单数据 · 会员明细列定义
 * ------------------------------------------------------------------
 * 列定义外置是「拆大文件」的主要手法（重构方案 §4.3）：页面文件只留取数与组合。
 *
 * 口径说明：
 *   · 金额列取源接口已格式化好的 `amountName`，**不要自行再格式化**，
 *     否则会出现后台显示与页面显示不一致；
 *   · 空值统一交给 DataTable 的默认占位（`--`），不在每列里重复写兜底
 *     （与 M1 §12.2 的 null 语义一致）。
 */
import React from 'react';
import { Avatar, Space } from 'antd';

export const tradeOrderColumns = [
  {
    title: '会员',
    dataIndex: 'nickName',
    render: (v, record) => (
      <Space size="small">
        <Avatar size={24} src={record.avatar || undefined}>
          {(v || '--').slice(0, 1)}
        </Avatar>
        <span>{v || '--'}</span>
      </Space>
    ),
  },
  { title: '手机号', dataIndex: 'phone' },
  { title: '商品/类型', dataIndex: 'orderTypeName' },
  { title: '金额', dataIndex: 'amountName' },
  { title: '支付时间', dataIndex: 'payTime' },
  { title: '来源', dataIndex: 'channelName' },
];

export default tradeOrderColumns;
